import React from 'react'

const IconLeftLines = () => {
  return (
    <svg width="95" height="131" viewBox="0 0 95 131" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M94 1C51.5 27.5 26 69.5 21 130.5" stroke="#CEDEF2" stroke-width="1.6" />
      <path d="M7.39844 104C14.4925 61.4606 32.8484 29.3433 60.9998 6.18164" stroke="#CEDEF2" stroke-width="1.6" />
      <path d="M33.1075 17.5C18.3188 34.3153 7.4214 54.6986 0.765137 79" stroke="#CEDEF2" />
    </svg>
  )
}

export default IconLeftLines
